"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLegacyKpiWithoutComparison = exports.isLegacyKpiWithComparison = exports.isLegacyKpi = void 0;
// (C) 2020-2022 GoodData Corporation
/* eslint-disable @typescript-eslint/no-empty-interface, import/namespace */
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * Type-guard testing whether the provided object is an instance of {@link ILegacyKpi}.
 * @deprecated Use {@link @gooddata/sdk-model#isKpi}
 * @alpha
 */
exports.isLegacyKpi = sdk_model_1.isKpi;
/**
 * Type-guard testing whether the provided object is an instance of {@link ILegacyKpiWithComparison}.
 * @deprecated Use {@link @gooddata/sdk-model#isKpiWithComparison}
 * @alpha
 */
exports.isLegacyKpiWithComparison = sdk_model_1.isKpiWithComparison;
/**
 * Type-guard testing whether the provided object is an instance of {@link ILegacyKpiWithoutComparison}.
 * @deprecated Use {@link @gooddata/sdk-model#isKpiWithoutComparison}
 * @alpha
 */
exports.isLegacyKpiWithoutComparison = sdk_model_1.isKpiWithoutComparison;
//# sourceMappingURL=kpi.js.map